export const formatNumberWithCommas = (num: number): string => {
  if (!num) return '';
  const numStr = num.toString();
  const parts = numStr.split('.');
  let reversed = parts[0].split('').reverse().join('');
  reversed = reversed.replace(/(\d{3})(?=\d)/g, '$1,');
  const formatted = reversed.split('').reverse().join('') + (parts[1] ? '.' + parts[1] : '');
  return formatted;
};